import * as React from "react";
import { forwardRef, memo } from "react";
const SvgClose = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", fill: "none", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 13L7.00002 7.00002M7.00002 7.00002L1 1M7.00002 7.00002L13 1M7.00002 7.00002L1 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClose);
const Memo = memo(ForwardRef);
export default Memo;
